import { z } from "zod";
import { SitePackageIdSchema } from "./site-package.js";
import { CheckResultSchema } from "./quality-gate-result.js";
export const RouteManifestV1Schema = z
    .object({
    schemaVersion: z.literal("route-manifest.v1.0"),
    sitePackageId: SitePackageIdSchema,
    routes: z.array(z.object({ routeId: z.string().min(1), path: z.string().min(1) }).strict()),
})
    .strict();
export const PageArtifactV1Schema = z
    .object({
    schemaVersion: z.literal("page-artifact.v1.0"),
    routeId: z.string().min(1),
    path: z.string().min(1),
    artifactName: z.string().min(1),
    artifactUri: z.string().min(1),
    clientSafe: z.boolean(),
})
    .strict();
export const PageQualityResultV1Schema = z
    .object({
    schemaVersion: z.literal("page-quality-result.v1.0"),
    routeId: z.string().min(1),
    artifactName: z.string().min(1),
    status: z.enum(["QA_PASS", "QA_WARN", "QA_FAIL", "QA_NOT_RUN"]),
    checks: z.array(CheckResultSchema),
})
    .strict();
export const PackageQualityAggregateV1Schema = z
    .object({
    schemaVersion: z.literal("package-quality-aggregate.v1.0"),
    sitePackageId: SitePackageIdSchema,
    pageResults: z.array(PageQualityResultV1Schema),
    aggregateStatus: z.enum(["QA_PASS", "QA_WARN", "QA_FAIL", "QA_NOT_RUN"]),
})
    .strict();
export const MultiPageExportManifestV1Schema = z
    .object({
    schemaVersion: z.literal("multi-page-export-manifest.v1.0"),
    sitePackageId: SitePackageIdSchema,
    routeManifest: RouteManifestV1Schema,
    pageArtifacts: z.array(PageArtifactV1Schema).min(1),
    packageQuality: PackageQualityAggregateV1Schema,
    artifactSetHash: z.string().min(1),
    exportedAt: z.string().datetime(),
})
    .strict();
export const ExportArtifactIndexV1Schema = z
    .object({
    schemaVersion: z.literal("export-artifact-index.v1.0"),
    runId: z.string().min(1),
    entries: z.array(z
        .object({
        artifactName: z.string().min(1),
        artifactUri: z.string().min(1),
        routeId: z.string().optional(),
        clientSafe: z.boolean(),
    })
        .strict()),
    artifactSetHash: z.string().min(1),
    indexedAt: z.string().datetime(),
})
    .strict();
export const ApprovedArtifactBindingV1Schema = z
    .object({
    schemaVersion: z.literal("approved-artifact-binding.v1.0"),
    runId: z.string().min(1),
    artifactSetHash: z.string().min(1),
    approvedAt: z.string().datetime(),
    approvedBy: z.string().min(1),
})
    .strict();
export const DepartureKitExportLinkageV1Schema = z
    .object({
    schemaVersion: z.literal("departure-kit-export-linkage.v1.0"),
    runId: z.string().min(1),
    artifactSetHash: z.string().min(1),
    departureKitVersion: z.string().min(1),
})
    .strict();
export const LaunchCertificateLinkageV1Schema = z
    .object({
    schemaVersion: z.literal("launch-certificate-linkage.v1.0"),
    runId: z.string().min(1),
    artifactSetHash: z.string().min(1),
    certificateId: z.string().min(1),
})
    .strict();
export const WebsiteOwnershipRecordLinkageV1Schema = z
    .object({
    schemaVersion: z.literal("website-ownership-record-linkage.v1.0"),
    runId: z.string().min(1),
    artifactSetHash: z.string().min(1),
    ownershipRecordId: z.string().min(1),
})
    .strict();
//# sourceMappingURL=multi-page-export.js.map